/* unplugin-vue-components disabled */import { render } from "./BoardFlashingAnimation.vue?vue&type=template&id=0b018010&scoped=true"
import script from "./BoardFlashingAnimation.vue?vue&type=script&lang=js"
export * from "./BoardFlashingAnimation.vue?vue&type=script&lang=js"

import "./BoardFlashingAnimation.vue?vue&type=style&index=0&id=0b018010&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b018010"]])

export default __exports__